module.exports = __webpack_public_path__ + "img/baner-6.webp";